export const agency = {
  activities: {
    activities: 'Aktivitetet',
    upcomingRenewals: 'Rinovimet e Ardhsme',
    subscriptionActivities: 'Aktivitetet e Abonimit',
    upcomingDowngradeRequests: 'Kërkesat e Rënieve të Ardhsme',
    serialNumber: 'Nr. Serik',
    email: 'Email',
    phoneNumber: 'Nr. i Telefonit',
    currentPlan: 'Plani Aktual',
    price: 'Çmimi',
    daysLeft: `Ditë të Mbetura`,
    noDataFound: {
      upcomingDowngrades: 'Rëniet e Ardhsme',
      noUpcomingDowngradesFoundYet: 'Ende nuk janë gjetur Rëniet e Ardhsme!',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Rinovimet e Ardhsme të Klientëve',
      subscriptionActivities: 'Aktivitetet e Abonimit',
      upcomingDowngradeRequestsOfCustomers: 'Kërkesat e Rënive të Ardhsme të Klientëve',
      serialNumber: 'Numri Serial',
      customerEmail: 'Email i Klientit',
      customerPhoneNumber: 'Nr. i Telefonit të Klientit',
      currentPlanOfCustomer: 'Plani Aktual i Klientit',
      currentPlanPrice: 'Çmimi aktual i Planit',
      daysLeft: `Ditë të Mbetura nga Plani aktual i Klientit`
    },
  },
  configuration: {
    configurationsHeader: 'Konfiguracionet',
    emailHeader: 'Email',
    razorPayHeader: 'RazorPay',
    invoiceDetailsHeader: 'Detajet e Faturës',
    stripeHeader: 'Stripe',
    retentionPolicyHeader: 'Politika e Ruajtjes',
    zohoHeader: 'Zoho',
    appTooltip: {
      integrateYourEmailProviderDetails: 'Integroni detajet e ofruesit tuaj të emailit për të dërguar email-e klientit pa problem.',
      enterYourRazorPayAccountDetails: 'Jepni detajet e llogarisë suaj RazorPay për procesim të lehtë të pagesave nga klientët.',
      enterYourStripeAccountDetails: 'Jepni detajet e llogarisë suaj Stripe për procesim të lehtë të pagesave nga klientët.',
      enterYourCompanyDetails: 'Jepni detajet e kompanisë suaj për fatura të sakta dhe gjenerim profesional të faturave.',
      retentionPolicyDescription: 'Politika e Mbajtjes është e projektuar për të menaxhuar ciklin e jetës së të dhënave brenda sistemit.',
      enterYourZohoKeys: 'Jepni Zoho Client ID dhe Zoho Client Secret Key për një integrim të suksesshëm.',
      enterYourGoogleKeys: 'Shkruani ID-në tuaj të klientit Google dhe çelësin e fshehtë të klientit Google për një integrim të suksesshëm.'
    },
    email: {
      testEmail: 'Email Test',
      addEmailIntegrationsDetails: 'Shto Detajet e Integrimin e Email-it',
      integrationDescription: 'Për të integruar detajet e ofruesit tuaj të emailit, ju lutemi sigurohuni' +
      'që keni informacionin e ofruesit tuaj të emailit.' +
        `Të gjitha email-at e komunikimit do t'i dërgohen klientëve tuaj duke përdorur këtë adresë emaili,
        duke siguruar dorëzim të vazhdueshëm dhe të besueshëm të njoftimeve dhe azhurnimeve të rëndësishme.`,
      awsRegion: 'AWS Rajon',
      awsAccessKeyId: 'AWS ID e Qasjes',
      awsSecretAccessKey: 'AWS Çelësi i Sekretit të Qasjes',
      reset: 'Rivendos',
      addDetails: 'Shto Detajet',
      updateDetails: 'Përditëso Detajet',
      fromEmail: 'Nga Email-i',
      appTooltip: {
        TOOLTIP_AWS_REGION: 'Jepni rajonin tuaj AWS. Rajoni përcakton vendndodhjen fizike' +
        'të burimeve tuaja dhe ndikon në faktorë si latencë e të dhënave dhe përmbushja e rregullores.',
        TOOLTIP_AWS_ACCESS_KEY_ID: 'Jepni ID e Qasjes tuaj të AWS. Ky çelës ju identifikon unikisht' +
        'llogarinë tuaj AWS dhe nevojitet për autentifikim të sigurt dhe qasje në shërbimet AWS.',
        TOOLTIP_AWS_SECRET_ACCESS_KEY_ID: 'Jepni Çelësin tuaj të Sekretit të Qasjes AWS. Ky çelës' +
        'përdoret për autentifikim të sigurt dhe qasje në shërbimet AWS.',
        fromEmail: 'E-Mail, die zum Senden aller Plattform-E-Mails verwendet wird (z. B. Lead-E-Mails, Kontowarnungen usw.)',
      },
      placeholders: {
        enterAwsRegion: 'Jepni rajonin AWS',
        enterAwsAccessKeyId: 'Jepni ID e Qasjes AWS',
        enterAwsSecretAccessKey: 'Jepni Çelësin e Sekretit të Qasjes AWS',
        enterFromEmail: 'Hyni nga emaili'
      },
      modal: {
        deleteEmailIntegration: 'Fshi Integrimin e Email-it',
        wantToDeleteEmailIntegration: 'A jeni i sigurt që dëshironi të fshini këtë Integrim të Email-it?',
      }
    },
    facebook: {
      addFacebookIntegrationsDetails: 'Shto Detajet e Integrimin e Facebook-ut',
      integrateYourEmailProviderDetails: 'Integroni detajet e ofruesit tuaj të emailit. Të gjitha email-at do të dërgohen duke përdorur këtë email tek klientët tuaj',
      facebookAppId: 'Facebook ID e Aplikacionit',
      facebookSecretAccessKey: 'Facebook Çelësi i Sekretit të Qasjes',
      reset: 'Rivendos',
      cancel: 'Anulo',
      addDetails: 'Shto Detajet',
      updateDetails: 'Përditëso Detajet',
      delete: 'Fshi',
      testEmail: 'Email Test',
      modal: {
        deleteFacebookIntegration: 'Fshi Integrimin e Facebook-ut',
        wantToDeleteFacebookIntegration: 'A jeni i sigurt që dëshironi të fshini këtë Integrim të Facebook-ut?'
      },
      placeholders: {
        enterFacebookAccessKeyId: 'Jepni Facebook Çelësin e Sekretit të Qasjes',
        enterFacebookAppId: 'Jepni Facebook ID e Aplikacionit'
      },
      appTooltip: {
        TOOLTIP_WAITING_MESSAGES: 'Përsonalizoni mesazhin ashtu si dëshironi që të shfaqet në dritaren e bisedës menjëherë pasi një përdorues bote dërgon kërkesë për Bisedë të Drejtpërdrejtë',
      }
    },
    invoiceDetails: {
      addInvoiceDetails: 'Shto Detajet e Faturës',
      invoicesDescription: 'Për të gjeneruar fatura për klientët tuaj, ju lutemi sigurohuni që keni detajet e kompanisë suaj, duke përfshirë emrin e kompanisë tuaj,' +
        'adresën, informacionin e kontaktit dhe çdo informacion të tjera të nevojshëm për fatura të sakta.' +
        'Këto informacione do të përdoren për të krijuar fatura profesionale në emër të kompanisë suaj për çdo transaksion.',
      companyName: 'Emri i Kompanisë',
      country: 'Shteti',
      selectCountry: 'Zgjidh Shtetin',
      stateOrRegion: 'Shteti/Rajoni',
      streetAddress: 'Adresa',
      gstin: 'GSTIN',
      postalCode: 'Kodi Postal',
      addDetails: 'Shto Detajet',
      updateDetails: 'Përditëso Detajet',
      reset: 'Rivendos',
      delete: 'Fshi',
      loadMore: 'Ngarko Më Shumë',
      time: 'Koha',
      phoneNumber: 'Numri i Telefonit',
      email: 'Email',
      status: 'Statusi',
      message: 'Mesazhi',
      response: 'Përgjigja',
      placeOfSupply: 'Vendi i Furnizimit',
      placeholders: {
        enterYourCompanyName: 'Jepni emrin e kompanisë suaj',
        enterYourStateOrRegion: 'Jepni shtetin/rajonin tuaj',
        enterYourStreetAddress: 'Jepni adresën tuaj',
        enterYourGstin: 'Jepni GSTIN tuaj',
        enterPostalCode: 'Jepni kodin postal',
        enterPlaceOfSupply: 'Jepni vendin e furnizimit'
      },
      modal: {
        deleteEmailIntegration: 'Fshi Integrimin e Email-it',
        wantToDeleteEmailIntegration: 'A jeni i sigurt që dëshironi të fshini këtë Integrim të Email-it?',
      },
      appTooltip: {
        TOOLTIP_COMPANY_NAME:
          'Jepni emrin e kompanisë suaj. Këto informacione do të përdoren për qëllime identifikimi dhe markimi në faturat.',
        TOOLTIP_COUNTRY: 'Zgjidhni Shtetin tuaj. Këto informacione do të përdoren për qëllime identifikimi dhe markimi në faturat.',
        TOOLTIP_STATE: 'Jepni Shtetin tuaj. Këto informacione do të përdoren për qëllime identifikimi dhe markimi në faturat.',
        TOOLTIP_STREET_ADDRESS: 'Jepni Adresën tuaj. Këto informacione do të përdoren për qëllime identifikimi dhe markimi në faturat.',
        TOOLTIP_GSTIN: 'Jepni GSTIN tuaj. Këto informacione do të përdoren për qëllime identifikimi dhe markimi në faturat.',
        TOOLTIP_POSTAL_CODE: 'Jepni Kodin tuaj Postal. Këto informacione do të përdoren për qëllime identifikimi dhe markimi në faturat.',
        TOOLTIP_PLACE_OF_SUPPLY: 'Jepni Vendin e Furnizimit. Këto informacione do të përdoren për qëllime identifikimi dhe markimi në faturat.',
      }
    },
    razorPay: {
      addRazorPayIntegrationsDetails: 'Add RAZORPAY Integration Details',
      integrationDescription: 'To integrate your RazorPay account details, please provide your RazorPay account information.' +
        ' All customer payments will be processed through your RazorPay account for seamless transactions',
      razorPayAccessKeyId: 'RAZORPAY Access Key Id',
      razorPaySecretAccessKey: 'RAZORPAY Secret Access Key',
      reset: 'Reset',
      addDetails: 'Add Details',
      updateDetails: 'Update Details',
      loadMore: 'Load More',
      time: 'Time',
      phoneNumber: 'Phone Number',
      email: 'Email',
      status: 'Status',
      message: 'Message',
      response: 'Response',
      placeholders: {
        enterRazorPayAccessKeyId: 'Enter Razorpay Access Key Id',
        enterRazorPaySecretAccessKey: 'Enter Razorpay Secret Access Key',
        enterRazorPayAccessId: 'Enter RazorPay Access Id',
      },
      appTooltip: {
        TOOLTIP_RAZORPAY_ID: 'Enter your Razorpay Access Key ID. This key uniquely identifies your integration' +
          ' with Razorpay and is required for secure payment transactions.',
        TOOLTIP_RAZORPAY_SECRET_KEY: 'Enter your Razorpay Secret Access Key. This key is essential for secure communication between' +
          'application and Razorpay, enabling seamless transaction processing and payment management.',
      },
      modal: {
        deleteRazorPayIntegration: 'Delete Email Integration',
        wantToDeleteThisIntegrtion: 'Are you sure you want to delete this Email Integration?',
      }
    },
    stripe: {
      addStripeIntegrationDetails: 'Add Stripe Integration Details',
      integrationDescription: 'To integrate your Stripe account details, please provide your Stripe account information.' +
        ' All customer payments will be processed through your Stripe account for seamless transactions',
      stripeSecretAccessKey: 'Stripe Secret Access Key',
      stripePublicKey: 'Stripe Public Key',
      reset: 'Reset',
      addDetails: 'Add Details',
      updateDetails: 'Update Details',
      cancel: 'Cancel',
      loadMore: 'Load More',
      time: 'Time',
      phoneNumber: 'Phone Number',
      email: 'Email',
      status: 'Status',
      message: 'Message',
      response: 'Response',
      placeholders: {
        enterStripeSecretAccessKey: 'Enter Stripe Secret Access Key',
        enterStripePublicKey: 'Enter Stripe Public Key',
      },
      appTooltip: {
        TOOLTIP_STRIPE_SECRET_KEY: 'Enter your Stripe Secret Access Key. This key is used to securely authenticate your' +
          ' integration with Stripe and is necessary for processing customer payments.',
        TOOLTIP_PUBLIC_KEY: 'Enter your Stripe Public Key. This key is used to securely authenticate your integration with' +
          ' Stripe on client side and is necessary for processing customer payments.',
      },
      modal: {
        deleteStripeIntegration: 'Delete Stripe Integration',
        wantToDeleteStripeIntegration: 'Are you sure you want to delete this Stripe Integration?'
      }
    },
    retentionPolicy: {
      retentionPolicy: 'Politika e Mbajtjes',
      retentionPolicyDescription: 'Politika e Mbajtjes është e projektuar për të menaxhuar ciklin e jetës së të dhënave brenda sistemit, duke specifikuar sa kohë të dhënat duhet të mbahen para se ato të fshihen sistemikisht dhe sigurt. Kjo politikë synon të sigurojë përputhshmërinë me rregulloret e mbrojtjes së të dhënave, të optimizojë burimet e ruajtjes dhe të menaxhojë të dhënat në një mënyrë efikase dhe të organizuar.',
      apiLogs: 'Ditët e Mbajtjes së Regjistrimeve të API-ve',
      selectApiLogs: 'Zgjidh Ditët e Mbajtjes së Regjistrimeve të API-ve',
      update: 'Përditëso',
      save: 'Ruaj',
      day: 'ditë',
      days: 'ditë',
      placeholders: {
        enterNumberOfDays: 'Vendos numrin e ditëve'
      },
    },
    zoho: {
      addZohoIntegrationDetails: 'Add Zoho Integration Details',
      zohoDescription: `Connect your chatbot platform with Zoho CRM, Zoho Projects, and Zoho Desk effortlessly.
       It will allow your users to automatically transfer their chatbot's captured lead data and create tasks in respective
        Zoho modules. To initiate a successful integration, provide your Zoho Client ID and Zoho Client Secret Key.`,
      zohoClientId: 'Zoho Client Id',
      zohoClientSecret: 'Zoho Client Secret',
      zohoCrmExtensionUrl: 'Zoho CRM Extension URL',
      add: 'Add',
      update: 'Update',
      placeholders: {
        enterZohoClientId: 'Enter your zoho client id',
        enterZohoClientSecret: 'Enter your zoho client secret',
        enterZohoCrmExtensionUrl: 'Enter your zoho crm extension url'
      }
    },
    google: {
      addGoogleIntegrationDetails: 'Shtoni Detajet e Integrimin me Google',
      googleDescription: `Lidhni Final_Brand tuaj me Detyrat e Google, Kontaktet e Google, Kalendarin e Google, Fletët e Google dhe Analizat e Google pa mundim. Kjo e mundëson përdoruesit të konfigurojnë automatizimin e rrjedhës së punës duke transferuar të dhënat e kapura nga chatbot te aplikacionet e preferuara të Google. Për të filluar një integrim të suksesshëm, sigurohuni që keni ID-në dhe çelësin e fshehtë të klientit tuaj të Google.`,
      googleClientId: 'ID e Klientit të Google',
      googleClientSecret: 'Çelësi i fshehtë i Klientit të Google',
      add: 'Shto',
      update: 'Përditëso',
      placeholders: {
        enterGoogleClientId: 'Vendosni ID-në tuaj të klientit të Google',
        enterGoogleClientSecret: 'Vendosni çelësin e fshehtë të klientit tuaj të Google',
      }
    }
  },
  customer: {
    manageCustomers: 'Menaxho Klientët',
    addNewCustomers: 'Shto Klientë të Rinj',
    ensureYouHaveAddedAllYourCustomersHere: 'Sigurohu që ke shtuar të gjithë klientët këtu',
    customerName: 'Emri i Klientit',
    nameIsRequired: 'Emri është i detyrueshëm',
    emailId: 'ID e Email-it',
    enterAValidEmail: 'Vendos një email të vlefshëm',
    createPassword: 'Krijo Fjalëkalim',
    enterAStrongPassword: 'Vendos një fjalëkalim të fortë',
    confirmPassword: 'Konfirmo Fjalëkalimin',
    cancel: 'Anulo',
    customer: 'Klient',
    searchByNameOrEmail: 'Kërko sipas emrit ose email-it',
    filters: 'Filtrat',
    allCustomers: 'Të gjithë Klientët',
    paidCustomers: 'Klientë të Pagesës',
    freeCustomers: 'Klientë Pa Pagesë',
    messageAddOnCustomers: 'Klientët me Shtesë Mesazhe',
    botWhiteLabelCustomers: 'Klientët Whitelabel të Bot-it',
    sortBy: 'Rendit sipas',
    sortByFrequency: 'Rendit sipas frekuencës',
    all: 'Të gjithë',
    joinedDate: 'Data e Bashkimit',
    plan: 'Plan',
    lastLogin: 'Hyrja e fundit',
    email: 'Email',
    nextDue: 'E ardhmja e Detyrueshme',
    frequency: 'Frekuenca',
    clearAll: 'Pastro të Gjitha',
    apply: 'Apliko',
    messageConsumed: 'Mesazhet e Konsumuara',
    addCustomer: 'Shto Klient',
    serialNumber: 'Nr. Serik',
    name: 'Emri',
    contact: 'Kontakti',
    limit: 'Kufiri',
    location: 'Vendndodhja',
    actions: 'Veprimet',
    joinedOn: 'Bashkohet më',
    typeOfCustomer: 'Lloji i Klientit',
    exceptWhatsapp: ' (Përveç Whatsapp)',
    exceptWA: '(Përveç WA)',
    wa: '(WA)',
    loadMore: 'Ngarko më shumë',
    conversationsWhatsapp: ' Bisedat (Whatsapp)',
    appTooltip: {
      enterCustomerEmail: 'Vendos emailin e klientit',
      enterCustomerPassword: 'Vendos fjalëkalimin e klientit',
      enterCustomerConfirmPassword: 'Vendos konfirmimin e fjalëkalimit të klientit',
      enterCustomerName: 'Vendos emrin e klientit',
    },
    placeholders: {
      enterCustomerEmail: 'Vendos emailin e klientit',
      searchByNameOrEmail: 'Kërko sipas emrit ose email-it',
      enterPassword: 'Vendos fjalëkalimin',
      enterCustomerName: 'Vendos emrin e klientit',
    }
  },
  dashboard: {
    dashboard: 'Paneli',
    overview: 'Pasqyra',
    totalCustomers: 'Klientët Totalë',
    paidCustomers: 'Klientët e Pagesës',
    freeCustomers: 'Klientët Pa Pagesë',
    thisWeeksSignUp: 'Regjistrimet e Kësaj Jave',
    todaysSignUp: 'Regjistrimet e Sotme',
    totalEarnings: 'Fitimet Totale',
    nA: 'EPA',
    customerName: 'Emri i Klientit',
    nameIsRequired: 'Emri është i detyrueshëm',
    emailId: 'ID e Email-it',
    enterAValidEmail: 'Vendos një email të vlefshëm',
    editCustomer: 'Redakto Klientin',
    recentSignUps: 'Regjistrimet e Fundit',
    serialNumber: 'Nr. Serik',
    name: 'Emri',
    email: 'Email',
    contact: 'Kontakti',
    plan: 'Plan',
    limit: 'Kufiri',
    location: 'Vendndodhja',
    lastLogin: 'Hyrja e Fundit',
    joinedOn: 'Bashkohet më',
    actions: 'Veprimet',
    exceptWhatsapp: ' (Përveç Whatsapp)',
    messageConsumed: 'Mesazhet e Konsumuara',
    conversationsWhatsapp: 'Bisedat (Whatsapp)',
    placeholders: {
      enterCustomerName: 'Vendos emrin e klientit',
      enterCustomerEmail: 'Vendos emailin e klientit',
    },
    modal: {
      deleteCustomer: 'Fshi Klientin',
      areYouSure: 'A jeni të sigurt se dëshironi të fshini këtë klient?'
    }
  },
  downgradeRequests: {
    activites: 'Aktivitete',
    upcomingRenewals: 'Rinovimet e Ardhshme',
    subscriptionActivities: 'Aktivitetet e Abonimit',
    upcomingDonwgradeRequests: 'Kërkesat e Ardhshme për Zvogëlim',
    serialNumber: 'Nr. Serik',
    email: 'Email',
    phoneNumber: 'Numri i Telefonit',
    currentPlan: 'Plan Aktual',
    requestedOn: 'Kërkuar Më',
    downgradeOn: 'Zvogëluar Më',
    nA: 'EPA',
    commaMonthly: ', Mujor',
    commaYearly: ', Vjetor',
    noDataFound: {
      downgradeRequests: `Kërkesat për Zvogëlim`,
      noDowngradeRequestFound: `Nuk u gjetën ende kërkesa për zvogëlim!`,
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Rinovimet e ardhshme të klientëve',
      subscriptionActivities: 'Aktivitetet e abonimit',
      upcomingDowngradeOfCustomers: 'Kërkesat e ardhshme për zvogëlim të klientëve',
      serialNumber: 'Numri serial',
      customerEmail: 'Email-i i klientit',
      customerPhoneNumber: 'Numri i telefonit të klientit',
      currentPlanOfCustomer: 'Plan aktual i klientit',
      currentPlanPrice: 'Çmimi aktual i planit',
    }
  },
  emailIntegration: {
    emailIntegration: 'Integrimi i Email-it',
    addEmailIntegrationDetails: 'Shto Detajet e Integrimin e Email-it',
    integrateYourEmailProviderDetails: 'Integrini detajet e ofruesit tuaj të email-it. Të gjithë email-et do të dërgohen duke përdorur këtë email tek klientët tuaj',
    awsRegion: 'AWS Rajoni',
    awsRegionIsRequired: 'AWS Rajoni është i detyrueshëm',
    awsAccessKeyId: 'AWS ID e Qasjes',
    awsAccessKeyIdIsRequired: 'AWS ID e Qasjes është i detyrueshëm',
    awsSecretAccessKey: 'AWS Çelësi Sekret i Qasjes',
    awsSecretAccessKeyIsRequired: 'AWS Çelësi Sekret i Qasjes është i detyrueshëm',
    cancel: 'Anulo',
    test: 'Testo',
    action: 'Veprim',
    testEmail: 'Email Test',
    addDetails: 'Shto Detajet',
    updateDetails: 'Përditëso Detajet',
    saveDetails: 'Ruaj Detajet',
    placeholders: {
      enterAwsRegion: 'Vendos AWS Rajonin',
      enterAwsAccessKeyId: 'Vendos AWS ID e Qasjes',
      enterAwsSecretAccessKey: 'Vendos AWS Çelësin Sekret të Qasjes',
    },
    modal: {
      deleteEmailIntegration: 'Fshi Integrimin e Email-it',
      areYouSure: 'A jeni të sigurt që dëshironi të fshini këtë Integrim të Email-it?',
    },
    noDataFound: {
      emailIntegration: 'Integrimi i Email-it',
      noEmailIntegrationFoundYet: 'Ende nuk u gjet Integrim i Email-it!',
    }
  },
  subscription: {
    activities: 'Aktivitetet',
    upcomingRenewals: 'Rinovimet e Ardhshme',
    subscriptionActivities: 'Aktivitetet e Abonimit',
    upcomingDonwgradeRequests: 'Kërkesat e Ardhshme për Zvogëlim',
    filters: 'Filtra',
    manageActivities: 'Menaxho Aktivitetet',
    sortBy: 'Rendit sipas',
    all: 'Të gjitha',
    upgrades: 'Ngritjet',
    donwgrades: 'Zvogëlimet',
    renewals: 'Rinovimi',
    serialNumber: 'Nr. Serik',
    email: 'Email',
    phoneNumber: 'Nr. i Telefonit',
    previousPlan: 'Plan i Mëparshëm',
    newPlan: 'Plan i Ri',
    description: 'Përshkrim',
    date: 'Data',
    nA: 'EPA',
    upgraded: 'ngritur',
    commaYearly: ' , Vjetor',
    commaMonthly: ' , Mujor',
    noDataFound: {
      noSubscriptionActivitiesFoundYet: 'Ende nuk u gjetën aktivitete abonimi!',
      subscriptionsActivities: 'Aktivitetet e Abonimeve',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Rinovimet e ardhshme të klientëve',
      subscriptionActivities: 'Aktivitetet e abonimit',
      upcomingDowngradeRequests: 'Kërkesat e ardhshme për zvogëlim të klientëve',
      serialNumber: 'Nr. serik',
      customerEmail: 'Email-i i klientit',
      customerPhoneNumber: 'Nr. i telefonit të klientit',
      previousPlan: 'Plan i mëparshëm i klientit',
      newPlan: 'Plan i ri i klientit',
      description: 'Përshkrimi i planit',
      typeOfPayment: 'Lloji i Pagesës',
    }
  },
  feedbacks: {
    feedbacks: 'Retroksionet',
    serialNumber: 'Nr. Serik',
    customer: 'Klienti',
    type: 'Lloji',
    rating: 'Vlerësimi',
    reason: 'Arsyeja',
    description: 'Përshkrimi',
    createdAt: 'Krijuar Më',
    nA: 'EPA',
    loadMore: 'Ngarko Më Shumë',
    dataNotFound: {
      accountAndBotDeletionFeedbacks: 'Retroksionet për Fshirjen e Llogarisë dhe Botit',
      noFeedbacksFoundYet: 'Ende nuk u gjet asnjë retroksion!',
    },
    appTooltip: {
      serialNumber: 'Nr. serik',
      customerEmail: 'Email-i i klientit',
      feedbackForBotOrAccountDeletion: 'Retroksion për (Fshirjen e Botit/Llogarisë)',
      customerRating: 'Vlerësimi i klientit',
      customerReason: 'Arsyeja e klientit',
      feedbackCreatedAt: 'Retroksioni i krijuar më',
      customerFeedback: 'Retroksioni i Klientit',
    }
  },
  emailActivity: {
    emailActivityHeading: 'Aktiviteti i Email-it',
    heading: 'Aktiviteti Juaj i Email-it',
    subHeading: 'Regjistrot e email-eve për agjensinë bazë',
    searchLabel: 'Filtro sipas emrit të klientit',
    customerName: 'Emri i Klientit',
    emailType: 'Lloji i Email-it',
    fromEmail: 'Nga Email-i',
    toEmail: 'Tek Email-i',
    createdAt: 'Krijuar Më',
    action: 'Veprim',
    loadMore: 'Ngarko Më Shumë',
    noEmailActivityYet: 'Ende nuk u gjet aktivitet email-i!',
  }
};
